import "../styles/Legal.css";

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Pribatutasun-politika</h1>

      <p>
        Datu pertsonalen babesari buruzko indarreko araudia betez, erabiltzaileei
        honako informazio hau ematen zaie.
      </p>

      <h2>Tratamenduaren arduraduna</h2>
      <p>
        Alaiak Mungialdeko Soinulari Elkartea
        <br />
        Posta elektronikoa: soinulariakmungia@alaiak.eus
      </p>

      <h2>Zer datu biltzen dira</h2>
      <p>Webgune honen bidez honako datu hauek bildu daitezke:</p>
      <ul>
        <li>Izena</li>
        <li>Posta elektronikoa</li>
        <li>Harremanetarako formularioaren bidez bidalitako mezua</li>
        <li>
          Administrazio gunera sartzeko datuak, baimendutako erabiltzaileentzat
          soilik
        </li>
      </ul>

      <h2>Datuen tratamenduaren helburua</h2>
      <ul>
        <li>Harremanetarako formularioaren bidez jasotako eskaerei erantzutea</li>
        <li>Elkartearekin lotutako komunikazioak kudeatzea</li>
        <li>Webguneko administrazio gunearen sarbidea eta kudeaketa bermatzea</li>
        <li>Webgunearen segurtasuna eta funtzionamendu egokia zaintzea</li>
      </ul>

      <h2>Tratamenduaren legitimazioa</h2>
      <p>
        Datuen tratamendua erabiltzailearen baimenean oinarritzen da,
        formularioa bidaltzean edo webguneko zerbitzuak erabiltzean.
      </p>
      <p>
        Administrazio guneko sarbideari dagokionez, tratamendua webgunearen
        kudeaketa eta segurtasun beharrean oinarritzen da.
      </p>

      <h2>Datuen kontserbazio-epea</h2>
      <p>
        Datu pertsonalak beharrezkoa den denboran gordeko dira jasotako eskaerari
        erantzuteko, webgunearen administrazioa kudeatzeko eta, hala badagokio,
        legez ezarritako betebeharrak betetzeko.
      </p>

      <h2>Datuen hartzaileak</h2>
      <p>
        Ez dira datu pertsonalak hirugarrenei lagako, lege-betebeharra dagoenean
        izan ezik.
      </p>

      <h2>Erabiltzaileen eskubideak</h2>
      <p>
        Erabiltzaileak honako eskubide hauek erabil ditzake bere datu
        pertsonalei dagokienez:
      </p>
      <ul>
        <li>Sarbidea</li>
        <li>Zuzenketa</li>
        <li>Ezabaketa</li>
        <li>Tratamendua mugatzea</li>
        <li>Aurkakotasuna</li>
      </ul>
      <p>
        Eskubide horiek erabiltzeko, mezu bat bidali daiteke helbide honetara:
        <br />
        <strong>soinulariakmungia@alaiak.eus</strong>
      </p>

      <h2>Datuen segurtasuna</h2>
      <p>
        Alaiak Mungialdeko Soinulari Elkarteak neurri tekniko eta antolakuntzazko
        egokiak hartzen ditu datu pertsonalen segurtasuna bermatzeko eta datu
        horiek galdu, aldatu edo baimenik gabe atzitzea saihesteko.
      </p>
    </div>
  );
}